import { Stack } from '@mui/material';
import RadioLikeSelectCard from 'Global/Components/CommonComponents/RadioLikeSelectCard/RadioLikeSelectCard';
import React from 'react';
import Receiption_Information from '../Receiption_Information/Receiption_Information';
import { actions } from '../Receiption_Information/actions/actions';

const Receiption = ({
  receiption,
  setReceptions,
  details,
}) => {
  return (
    <React.Fragment>
      <Stack gap=".3em">
        <RadioLikeSelectCard
          VerticalIcons={true}
          customtitle={
            <Receiption_Information
              receiption={receiption}
            />
          }
          isAction={true}
          ArrayActions={actions(
            receiption,
            setReceptions,
            details
          )}
        />
      </Stack>
    </React.Fragment>
  );
};

export default Receiption;
